/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import { Link, useHistory, useLocation, withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import {
  TopNavBarVertical,
  LogoChalkTalk,
  NavBarItem,
  DropdownWrap,
  DropdownItem,
  UserIconInitials,
} from './TopNavBar.style';
import { OverlayWrap } from '../Generals/stylesheets/General.style';
import { ROLE_TYPE } from '../../utils/enums';
import { getExternalLink } from '../../apis/curriculum';
import { actions as AuthActions } from '../../reducers/auth';
import { getCurrentUser } from '../../reducers/user';
import { selectors as courseSelectors } from '../../reducers/courses';
import { selectors as sectionSelectors } from '../../reducers/sections';
import {
  selectors as CurriculumSelectors,
  actions as CurriculumActions,
} from '../../reducers/curriculums';
import TeacherNavBar from './TeacherNavBar';
import StudentNavBar from './StudentNavBar';
import DistrictAdminNavBar from './DistrictAdminNavBar';
import ShadowScrollbar from '../Scrollbar/ShadowScrollbars';
import { useInteractionContext } from '@components/ElementAnalytics/InteractionContext';

const TopNavBar = () => {
  const { getTestId } = useInteractionContext();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  // Extract state from Redux using hooks
  const pathname = _get(location, 'pathname', '/');
  const paramsArray = pathname.split('/');
  const courseId =
    _get(paramsArray, '3', null) && !isNaN(_get(paramsArray, '3', null))
      ? _get(paramsArray, '3', null)
      : null;
  const sectionId = _get(paramsArray, '5', null);

  const searchParams = new URLSearchParams(location.search);
  const isOpenTeacherCourseSetupFromUrl = !!searchParams.get('isOpenTeacherCourseSetup');

  const user = useSelector((state) => getCurrentUser(state));
  const courseList = useSelector((state) => courseSelectors.getCourseList(state));
  const sectionList = useSelector((state) => sectionSelectors.getSectionList(state));
  const courseById = useSelector((state) => courseSelectors.getCourseListIds(state));
  const courseData = useSelector((state) =>
    courseSelectors.getCourseDetailById(state, courseId),
  );
  // Get curriculumId from current course, or fall back to first course's curriculum
  const curriculumIdFromCurrentCourse = _get(courseData, 'curriculum', '');
  const fallbackCurriculumId = _get(courseList, '[0].curriculum', '');
  const curriculumId = curriculumIdFromCurrentCourse || fallbackCurriculumId;
  const curriculumDetail = useSelector((state) =>
    CurriculumSelectors.getCurriculumById(state, curriculumId),
  );
  const coauthorEnabled = useSelector((state) =>
    CurriculumSelectors.isCoAuthorEnabled(
      state,
      courseList.map((c) => c.curriculum),
    ),
  );

  // Local state
  const [isDropdown, setIsDropdown] = useState(false);
  const [isCreateCourseOpen, setIsCreateCourseOpen] = useState(
    isOpenTeacherCourseSetupFromUrl,
  );
  const [currentSectionId, setCurrentSectionId] = useState(sectionId);
  const [gettingCurriculums, setGettingCurriculums] = useState(false);

  // Actions
  const logout = () => dispatch(AuthActions.logout());
  const getCurriculumList = () => dispatch(CurriculumActions.getCurriculumList());

  useEffect(() => {
    if (_isEmpty(curriculumDetail) && !gettingCurriculums) {
      setGettingCurriculums(true);
      getCurriculumList();
    }
  }, [curriculumDetail, gettingCurriculums, getCurriculumList]);

  useEffect(() => {
    if (isOpenTeacherCourseSetupFromUrl) {
      setIsCreateCourseOpen(true);
    }
  }, [isOpenTeacherCourseSetupFromUrl]);

  useEffect(() => {
    if (sectionId && currentSectionId !== sectionId) {
      setCurrentSectionId(sectionId);
    }
  }, [sectionId, currentSectionId]);

  const toggleDropdown = () => {
    setIsDropdown((prevState) => !prevState);
  };

  const openCreateCourseForm = () => {
    setIsCreateCourseOpen(true);
  };

  const closeCreateCourseForm = () => {
    setIsCreateCourseOpen(false);
  };

  const redirectPage = (link) => {
    const { role } = user;
    let url = link;

    if (role === ROLE_TYPE.DISTRICT_ADMIN) {
      history.push(url);
      return;
    }

    if (courseList.length === 0) {
      if (role === ROLE_TYPE.STUDENT) {
        history.push('/section-enroll');
      } else {
        openCreateCourseForm();
      }
      return;
    }

    if (sectionList.length === 0) {
      if (role === ROLE_TYPE.STUDENT) {
        history.push('/section-enroll');
      } else {
        const selectedCourseId = courseId || _get(courseList, '[0].id', '');
        history.push(
          `/management/course/${selectedCourseId}?isOpenCreateSection=${Math.round(
            Math.random() * 100 + 1,
          )}`,
        );
      }
      return;
    }

    try {
      const section = sectionList.find((ele) => ele.id == currentSectionId);
      if (section) {
        const scheduled = Object.keys(section.section_scheduled_subjects);
        if (section.subjects.length <= 1 && scheduled.length <= 1) {
          if (section.section_scheduled_subjects[scheduled[0]].scheduled === 0) {
            if (role === ROLE_TYPE.INSTRUCTOR) {
              const selectedCourseId = courseId || _get(courseList, '[0].id', '');
              url = `/schedule/course/${selectedCourseId}/section/${section.id}/section-info`;
              history.push(url);
            }
            return;
          }
        }
      }
    } catch (err) {
      console.log(`${err} in courseId = ${courseId} -- --`);
    }

    history.push(url);
  };

  const redirectExternal = (url) => {
    getExternalLink(url).then((responseData) => {
      const link = responseData.response.data;
      window.open(link.url, '_blank');
    });
  };

  const renderDropdown = () => {
    const profilePath = courseId ? `/profile/course/${courseId}` : '/profile';
    return (
      <DropdownWrap onClick={toggleDropdown}>
        <Link to={profilePath} data-testid={getTestId('profile-link')} tabIndex={0} style={{ display: 'inline-block' }}>
          <DropdownItem>Profile</DropdownItem>
        </Link>
        <DropdownItem tabIndex={0} onClick={logout} data-testid={getTestId('logout')} onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            logout();
          }
        }}>
          Logout
        </DropdownItem>
      </DropdownWrap>
    );
  };

  const getInitials = ({ first_name: firstName, last_name: lastName, email }) => {
    const initials = firstName[0] + lastName[0];
    if (!initials) {
      return email[0].toUpperCase();
    }
    return initials;
  };

  const renderUserIcon = (user, isDropdown) => {
    const initials = getInitials(user);
    return (
      <NavBarItem isActive={isDropdown} data-testid={getTestId('user-icon')} tabIndex={0}
        onClick={toggleDropdown} onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleDropdown();
          }
        }}>
        <UserIconInitials
          initials={initials}
          data-tip="Profile"
          data-for="tooltip-top-nav-bar"
        >
          <p>{initials}</p>
        </UserIconInitials>
      </NavBarItem>
    );
  };

  // Create props for NavBarItemComponent
  // Use fallbacks for courseId and sectionId to preserve navigation when on admin pages
  const effectiveCourseId = courseId || _get(courseList, '[0].id', null);
  const effectiveSectionId =
    sectionId || currentSectionId || _get(sectionList, '[0].id', null);
  const navBarItemProps = {
    courseId: effectiveCourseId,
    sectionId: effectiveSectionId,
    courseList,
    pathname,
    redirectPage,
    redirectExternal,
  };

  if (!user.role) {
    return null;
  }

  return (
    <TopNavBarVertical role='navigation' aria-label='Main navigation'>
      <ReactTooltip place="right" effect="solid" id="tooltip-top-nav-bar" />
      <LogoChalkTalk>
        <img src="/images/icon-v2/logo-chalktalk.png" alt="Logo ChalkTalk" />
      </LogoChalkTalk>
      <ShadowScrollbar autoHide style={{ width: '100%', height: '100%' }}>
        {user.role === ROLE_TYPE.STUDENT ? (
          <StudentNavBar
            state={{ isDropdown }}
            props={{ user, curriculumDetail }}
            navBarItemProps={navBarItemProps}
            renderUserIcon={renderUserIcon}
          />
        ) : user.role === ROLE_TYPE.DISTRICT_ADMIN ? (
          <DistrictAdminNavBar
            state={{ isDropdown }}
            props={{ user }}
            navBarItemProps={navBarItemProps}
            renderUserIcon={renderUserIcon}
          />
        ) : (
          <TeacherNavBar
            state={{ isDropdown, isCreateCourseOpen, coauthorEnabled }}
            props={{ user, curriculumDetail }}
            navBarItemProps={navBarItemProps}
            renderUserIcon={renderUserIcon}
            closeCreateCourseForm={closeCreateCourseForm}
            openCreateCourseForm={openCreateCourseForm}
          />
        )}
      </ShadowScrollbar>

      {isDropdown && (
        <>
          <OverlayWrap isOpen={isDropdown} onClick={toggleDropdown} />
          {renderDropdown()}
        </>
      )}
    </TopNavBarVertical>
  );
};

// Export the component wrapped with withRouter
export default withRouter(TopNavBar);
